export default __webpack_public_path__ + "11a816dd0d8d8006727bcb8db816ba47.pdf";